import React from 'react'

import duetsWithMyWhanau from '../../images/DUETS W MY WHANAU.jpg'
import duetsWithMyWhanau2 from '../../images/DUETS W MY WHANAU 2.jpg'

function DuetsWithMyWhanau() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={duetsWithMyWhanau}
            className="project-image" />
          <img
            src={duetsWithMyWhanau2}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Duets With My Whanau</h1>
          <h4>Bats Theatre Residency 2020</h4>
          <br />
          <p className="Project-text">
            <strong>
              Duos / Duets - Myself and one other, in relationship. 
              <br />
              These others include:
              <br />
              my Grandmother Jennifer Shearer, my Dad Brent Gilbert, my
              uncle Kerry Gilbert, my Grandfather John Gilbert, my cousin Gwena Gilbert, my cousin Tully Gilbert and my cousin Elinor Gilbert.
              <br />
              <br />
              Supporting artists (thank you):
              <br />
              Ben Lemi, Ana Scotney, Freya Sadgrove, Samuel Austin
            </strong>
          </p>
          <p className="Project-testimonial">
          I so enjoyed being at the showing. Have been fizzing on it ever since! 
          </p>
          <h6 className="Testimonial-person">
            <strong>~Jonathan Hendry, Chief Executive, Bats Theatre</strong>
          </h6>
              <br />
          <p className="Project-text">
          I made a project that enabled me to connect and create with the Wellington contingent of my family. Instigated by the intention of exploring what special something we had to offer between us. What might happen if we chose to express, to play, to move, to build something together.
            <br />
            Funded by Bats Theatre. This one month long residency was a real life giver and safe space to create and think and doubt and dance, with my Whanau.
          </p>
        </div>
      </div>
    </div>
  )
}

export default DuetsWithMyWhanau
